function applyValidations(form, validations) {
  form
    .querySelectorAll("[data-validation-container]")
    .forEach((/** type HTMLDivElement */ container) => {
      const input = container.querySelector(
        '[data-validation="input"][data-validation-error-class]'
      );
      const /** @type HTMLSpanElement */ message = container.querySelector(
          '[data-validation="message"]'
        );
      if (!(container.dataset.validationContainer in validations)) {
        input?.classList.remove(input.dataset.validationErrorClass);
        message.innerText = "";
        return;
      }
      input?.classList.add(input.dataset.validationErrorClass);
      message.innerText = validations[container.dataset.validationContainer];
    });
}

function clearValidations(form) {
  form
    .querySelectorAll("[data-validation-container]")
    .forEach((/** type HTMLDivElement */ container) => {
      const input = container.querySelector(
        '[data-validation="input"][data-validation-error-class]'
      );
      const /** @type HTMLSpanElement */ message = container.querySelector(
          '[data-validation="message"]'
        );
      input?.classList.remove(input.dataset.validationErrorClass);
      message.innerText = "";
    });
}

export { applyValidations, clearValidations };
